export const GET_SUBJECTSSUBCATEGORY = "GET_SUBJECTSSUBCATEGORY"
export const GET_SUBJECTSSUBCATEGORY_SUCCESS = "GET_SUBJECTSSUBCATEGORY_SUCCESS"
export const ADD_SUBJECTSUBCATEGORY = "ADD_SUBJECTSUBCATEGORY"
export const ADD_SUBJECTSUBCATEGORY_SUCCESS = "ADD_SUBJECTSUBCATEGORY_SUCCESS"
export const RESET_STORE_SUBJECTSUBCATEGORY = "RESET_STORE_SUBJECTSUBCATEGORY"
export const DELETE_SUBJECTSUBCATEGORY = "DELETE_SUBJECTSUBCATEGORY"
export const DELETE_SUBJECTSUBCATEGORY_SUCCESS = "DELETE_SUBJECTSUBCATEGORY_SUCCESS"


